// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown-module__dropdown","right":"Dropdown-module__right","left":"Dropdown-module__left"};